import React from "react";
import { img, imgSrcSet } from "@/lib/img";

// Responsive, layout-stable image.
// - priority: hero/LCP image → eager + high fetchpriority (never lazy).
// - otherwise lazy + async decode.
// - widths/sizes drive srcset so phones download small variants (~800px max).
// - width/height reserve space to avoid layout shift (CLS).
export function Img({
  src,
  alt = "",
  widths = [400, 600, 800, 1200],
  sizes = "100vw",
  base = 800,
  priority = false,
  width,
  height,
  className,
  style,
  ...rest
}) {
  const srcSet = imgSrcSet(src, widths);
  if (!src) return null;
  return (
    <img
      src={img(src, base)}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "auto" : "async"}
      fetchPriority={priority ? "high" : undefined}
      data-no-opt="1"
      className={className}
      style={style}
      {...rest}
    />
  );
}

export default Img;
